import React, { useState, useEffect } from 'react';
import { List, Button, Tag, message, Typography } from 'antd';
import PujaSpinner from '../../components/PujaSpinner';
import {
  BellOutlined,
  MessageOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import { buyerService } from '../../services/api';
import dayjs from 'dayjs';

const { Text } = Typography;

const iconoTipo = (tipo) => {
  if (tipo === 'autorizacion') return <BellOutlined />;
  if (tipo === 'ticket') return <MessageOutlined />;
  return <CalendarOutlined />;
};

const Notificaciones = () => {
  const [loading, setLoading] = useState(true);
  const [notifs, setNotifs] = useState([]);
  const [marcandoTodas, setMarcandoTodas] = useState(false);

  useEffect(() => {
    fetchNotifs();
  }, []);

  const fetchNotifs = async () => {
    setLoading(true);
    try {
      const res = await buyerService.getNotificaciones();
      setNotifs(res.data || []);
    } catch (err) {
      message.error(err.response?.data?.error || 'Error al cargar notificaciones');
    } finally {
      setLoading(false);
    }
  };

  const marcarLeida = async (id) => {
    try {
      await buyerService.marcarLeida(id);
      setNotifs(prev => prev.map(n => n.id_notificacion === id ? { ...n, leida: true } : n));
    } catch {
      // silencioso
    }
  };

  const marcarTodasLeidas = async () => {
    setMarcandoTodas(true);
    try {
      await buyerService.marcarTodasLeidas();
      setNotifs(prev => prev.map(n => ({ ...n, leida: true })));
      message.success('Todas marcadas como leídas');
    } catch (err) {
      message.error(err.response?.data?.error || 'Error');
    } finally {
      setMarcandoTodas(false);
    }
  };

  const hayNoLeidas = notifs.some(n => !n.leida);

  if (loading) {
    return <PujaSpinner />;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
        <h2 style={{ margin: 0 }}>Notificaciones</h2>
        {hayNoLeidas && (
          <Button loading={marcandoTodas} onClick={marcarTodasLeidas}>
            Marcar todas como leídas
          </Button>
        )}
      </div>

      <List
        bordered
        dataSource={notifs}
        renderItem={(n) => (
          <List.Item
            style={{
              background: n.leida ? 'transparent' : '#e6f4ff',
              cursor: n.leida ? 'default' : 'pointer',
            }}
            onClick={() => { if (!n.leida) marcarLeida(n.id_notificacion); }}
            extra={
              !n.leida && (
                <Tag color="blue">Nueva</Tag>
              )
            }
          >
            <List.Item.Meta
              avatar={iconoTipo(n.tipo)}
              title={n.titulo}
              description={
                <>
                  {n.mensaje && <Text type="secondary">{n.mensaje}</Text>}
                  <br />
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {dayjs(n.created_at).format('DD/MM/YYYY HH:mm')}
                  </Text>
                </>
              }
            />
          </List.Item>
        )}
        locale={{ emptyText: 'No hay notificaciones' }}
      />
    </div>
  );
};

export default Notificaciones;
